import React from 'react';
import { withRouter } from 'react-router-dom';

import '../assets/css/style.css'

import CallCenterMain from './CallCenterMain'
import InstallerMain from './InstallerMain'



class Main extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            data:[],
            open:false,
            selected: {
                status: -1,
                type: -1,
                search:''
            },
            userRole: parseInt(localStorage.getItem('role')) 
        }
        this.wrapper = React.createRef();
        this.status = -1
        this.type = -1

        this.statusSelectRed = React.createRef();

        var token =  localStorage.getItem('token');
        if(token === null){
            this.goToLogin();
        }
    }

    goToLogin = () => {
        this.props.history.push('/login')
    }
    
    setOpen(arg){
        this.setState({
            open: arg
          });
    }

    changeType(e,event){
        this.setState({
            selected: {
                ...this.state.selected,
                type: event.target.value

            }
        })
    }

    changeStatus(e,event){
        this.setState({
            selected: {
                ...this.state.selected,
                status: event.target.value
            }
        })
    }

    changeSearch(e,event){
        this.setState({
            selected: {
                ...this.state.selected,
                search: event.target.value
            }
        })
    }

    render(){

        return <React.Fragment >
            
            {this.state.userRole === 1 && <CallCenterMain/>}
            {this.state.userRole === 0 && <InstallerMain/>}
        </React.Fragment>

        
        
        
    }
}
export default withRouter(Main);